import { render } from "./SuggestionSourceTag.vue?vue&type=template&id=087665ec"
import script from "./SuggestionSourceTag.vue?vue&type=script&lang=js"
export * from "./SuggestionSourceTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__